/**
 * number of non punctuation words in a message before
 * starting a new message
 */
export const MESSAGE_CHAR_LIMIT = 118;
/**
 * Time in ms before a message is considered stale
 */
export const MESSAGE_TTL = 6000;
/**
 * Format an array of Agora Words into a human readable string
 * @param words
 */
export const formatAgoraWords = (words) => words.reduce((finalStr, word, i) => {
    //don't add a space to the first word.
    return finalStr + formatAgoraWord(word, i > 0);
}, '');
/**
 * Format a single AgoraWord to a user readable string
 * @param word the word to format
 * @param addSpaceToNonPunctuation [default true] whether or not to prefix a non punctuation word with a space
 */
export const formatAgoraWord = (word, addSpaceToNonPunctuation = true) => {
    const prefix = isPunctuation(word) || !addSpaceToNonPunctuation ? '' : ' ';
    return prefix + word.text;
};
/**
 * Checks if the given text is punctuation
 * @param word the word to check if punctuation
 */
export const isPunctuation = (word) => 
//in case a non punctuation word starts with punctuation for some reason
word.text.length === 1 &&
    //a punctuation word should only ever contain the punctuation mark so if it's there, it's at index 0
    word.text.search(/(\.|!|\?|,)/) === 0;
/**
 * Takes an array of words and returns the non punctuation ones
 * @param words
 */
export const nonPunctuationWords = (words) => words.filter((word) => !isPunctuation(word));
/**
 * Takes some words, a uid and a username and generates a new Speaker object
 * to be used in the conversation
 * @param words
 * @param uid
 * @param username
 */
export const speakerFactory = (words, uid, username) => {
    return {
        user: {
            name: username,
            uid,
        },
        words,
        lastSpoke: new Date().getTime(),
    };
};
/**
 * Checks if the last time the given speaker spoke was longer ago than the MESSAGE_TTL
 * @param speaker
 */
export const isStaleMessage = (speaker) => speaker.lastSpoke < new Date().getTime() - MESSAGE_TTL;
/**
 * Checks if the given speaker is too full to hold any more characters.
 * @param speaker
 * @returns whether or not the message and username combined contain the max amount of characters
 */
export const isFullMessage = (speaker) => formatAgoraWords(speaker.words).length + speaker.user.name.length >=
    MESSAGE_CHAR_LIMIT;
